import { Injectable } from "@angular/core";
import { TokenAcessoEditor, TokenLogin } from "src/app/shared/models/login-response";
import { PermissionService } from "src/app/shared/services/permission.service";

@Injectable({
    providedIn: "root"
})

export class TokenEditorService {
    constructor(private permissionService: PermissionService) {}

    gerarTokenAcessoEditor(tokenLogin: TokenLogin): TokenAcessoEditor {
        return {
            accessToken: tokenLogin?.accessToken,
            refreshToken: tokenLogin?.refreshToken,
            expiresIn: tokenLogin?.expiresIn,
            usuario: {
                id: tokenLogin?.usuario.id,
                nome: tokenLogin?.usuario.nome,
                email: tokenLogin?.usuario.email,
                dataLogin: tokenLogin?.usuario.dataLogin,
                contratante: {
                id: tokenLogin?.usuario.contratante.id,
                utilizaEditor: tokenLogin?.usuario.contratante.utilizaEditor,
                },
                perfilIDs: tokenLogin?.usuario.perfilIDs,
                permiteManutencaoEmLote: this.permissionService.hasAreaPermissionOf('ManutencoesLote')
            },
        };
    }
}